import { render, staticRenderFns } from "./TreatmentAdviceCard.vue?vue&type=template&id=f9d92310&scoped=true&"
import script from "./TreatmentAdviceCard.vue?vue&type=script&lang=js&"
export * from "./TreatmentAdviceCard.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentAdviceCard.vue?vue&type=style&index=0&id=f9d92310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d92310",
  null
  
)

export default component.exports